<template>
  <div class="login-main">
    <nav-bar></nav-bar>
    <section class="order-details-start">
      <div
        class="review-container review-main text-capitalize position-relative"
      >
        <div class="row">
          <div class="text-center col-md-12 p-0 my-2 odr-loadr" v-if="loading">
            <b-spinner class="align-middle"></b-spinner>
          </div>
          <div class="col-md-12 p-0" v-for="(orders, index) in ordersDetail" :key="index">
            <div class="resturant-details d-flex justify-content-between align-items-center plr15 order-id">
              <div>
              <h4 class="text-left">
                {{ $t("Order") }} #{{ orders.order_id }}
              </h4>
            </div>
            <div>
              <button
                class="invoice-btn mouse-hover"
                :disabled="invoiceLoadingId === orders.order_id"
                @click="invoiceGenerate(orders.order_id)"
              >
                <b-spinner
                  v-if="invoiceLoadingId === orders.order_id"
                  small
                  class="align-middle"
                ></b-spinner>
                <svg
                  v-else
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.6185 1.02356C7.15267 1.11531 7.02582 1.14934 6.80208 1.24275C6.06184 1.55175 5.39177 2.21022 5.06782 2.94698C4.84738 3.4483 4.83488 3.55401 4.81546 5.08365L4.79711 6.52799L4.20971 6.55274C3.61269 6.57792 3.30687 6.63786 2.92999 6.8036C2.1928 7.12772 1.53244 7.80002 1.22649 8.53786C0.998496 9.08766 1.00116 9.04284 1.00116 12.3407C1.00116 15.6369 0.998625 15.5942 1.22563 16.1413C1.60119 17.0464 2.42672 17.7724 3.38117 18.037C3.51382 18.0737 3.88821 18.115 4.21315 18.1287L4.80398 18.1536V19.6924C4.80398 20.6542 4.82186 21.3166 4.85168 21.4589C5.0028 22.1808 5.61719 22.7949 6.34226 22.9488C6.66152 23.0166 17.294 23.0172 17.6176 22.9495C18.1648 22.8349 18.6818 22.4376 18.9323 21.9391C19.1389 21.528 19.1559 21.3572 19.1559 19.6924V18.1536L19.7467 18.1288C20.5318 18.0959 20.9631 17.969 21.5142 17.6087C22.2185 17.1483 22.757 16.3627 22.8985 15.589C22.9249 15.4449 22.9637 15.2935 22.9848 15.2525C23.0397 15.1456 23.0351 9.36326 22.9802 9.39725C22.9557 9.41242 22.9372 9.37469 22.9372 9.30929C22.9372 9.14201 22.8248 8.73565 22.7048 8.46915C22.2588 7.47852 21.3253 6.75547 20.2731 6.58553C20.1195 6.56073 19.8068 6.54028 19.5783 6.54011L19.1628 6.53976L19.1445 5.08953C19.1248 3.53914 19.113 3.44225 18.8801 2.92523C18.4345 1.93547 17.5006 1.21233 16.4488 1.04243C16.1853 0.999889 7.82944 0.982013 7.6185 1.02356ZM7.57553 2.34682C7.21351 2.4374 6.9428 2.59205 6.67059 2.86374C6.52737 3.0067 6.36606 3.21562 6.31214 3.32803C6.11233 3.74441 6.09411 3.90542 6.09359 5.26141L6.09308 6.53976H11.9799H17.8668V5.29575C17.8668 4.54601 17.8478 3.96128 17.8189 3.82403C17.6637 3.08616 17.0664 2.48888 16.3285 2.33367C15.986 2.26161 7.86725 2.27381 7.57553 2.34682ZM3.75122 7.88992C3.3892 7.9805 3.11849 8.13515 2.84628 8.40684C2.70306 8.5498 2.54175 8.75872 2.48783 8.87113C2.27027 9.32455 2.2698 9.33194 2.2698 12.3407C2.2698 15.3494 2.27027 15.3568 2.48783 15.8102C2.54175 15.9226 2.70306 16.1315 2.84628 16.2743C3.26468 16.6916 3.70241 16.8525 4.41936 16.8525H4.80398V15.7783V14.704H4.54127C4.34872 14.704 4.23279 14.6783 4.10714 14.6077C3.6722 14.3632 3.6722 13.7557 4.10714 13.5113L4.27855 13.4149H11.9768C19.4505 13.4149 19.6796 13.4173 19.8347 13.4964C20.0211 13.5915 20.1872 13.8567 20.1872 14.0595C20.1872 14.2622 20.0211 14.5274 19.8347 14.6225C19.73 14.6759 19.5854 14.704 19.4154 14.704H19.1559V15.7783V16.8525H19.5405C20.2625 16.8525 20.696 16.6936 21.1141 16.2755C21.395 15.9946 21.5651 15.6855 21.6432 15.3142C21.7097 14.9981 21.7097 9.6833 21.6432 9.36713C21.488 8.62925 20.8907 8.03197 20.1528 7.87677C19.8061 7.80381 4.04479 7.81648 3.75122 7.88992ZM4.09898 9.39188C3.67031 9.65138 3.6747 10.2395 4.10714 10.4826C4.27305 10.5758 4.31619 10.5789 5.44535 10.5789C6.77561 10.5789 6.84874 10.5635 7.02801 10.2445C7.15013 10.0272 7.15013 9.84152 7.02801 9.62426C6.84857 9.305 6.7763 9.28979 5.43951 9.29004C4.28267 9.29026 4.26458 9.29163 4.09898 9.39188ZM1 12.3407C1 13.9596 1.00533 14.6218 1.0119 13.8124C1.01843 13.0029 1.01843 11.6784 1.0119 10.869C1.00533 10.0595 1 10.7218 1 12.3407ZM6.09308 17.95C6.09308 21.0522 6.09669 21.2029 6.17459 21.3556C6.22241 21.4494 6.32692 21.5552 6.42751 21.6117L6.59892 21.7081H11.9768C17.2818 21.7081 17.3569 21.7069 17.5241 21.6216C17.6333 21.5659 17.7246 21.4746 17.7803 21.3654C17.8647 21.1999 17.8668 21.1183 17.8668 17.95V14.704H11.9799H6.09308V17.95ZM9.94286 16.267C9.5142 16.5265 9.51858 17.1147 9.95103 17.3577C10.1213 17.4534 10.1353 17.4541 11.9768 17.4541C13.7126 17.4541 13.8413 17.4489 13.9908 17.3726C14.1772 17.2775 14.3433 17.0123 14.3433 16.8095C14.3433 16.6068 14.1772 16.3416 13.9908 16.2465C13.8412 16.1702 13.7128 16.165 11.9709 16.1652L10.1107 16.1654L9.94286 16.267ZM9.94286 19.0171C9.5142 19.2766 9.51858 19.8648 9.95103 20.1078C10.1213 20.2035 10.1353 20.2041 11.9768 20.2041C13.7126 20.2041 13.8413 20.1989 13.9908 20.1226C14.1772 20.0275 14.3433 19.7623 14.3433 19.5596C14.3433 19.3569 14.1772 19.0917 13.9908 18.9966C13.8412 18.9203 13.7128 18.9151 11.9709 18.9153L10.1107 18.9155L9.94286 19.0171Z" fill="#EF2121"/>
                </svg>
              </button>
            </div>
            </div>
            <div class="orders-inner-main plr15 mt-2">
              <div class="orders-lst">
                <div class="order-item order-item-nw d-flex align-items-start pb-4">
                  <div class="smallimg-squre">
                    <img :src="orders.restaurant_image ? orders.restaurant_image  : imageErrorHandle"  @error="imageErrorHandle" />
                  </div>
                  
                  <div class="order-data ml-3 d-flex align-items-start justify-content-between w-100">
                    <div class="orderid-main">
                      <h6 class="mb-0">{{ orders.restaurant_name }}</h6>
                      <p class="mt-1" v-if="orders && orders.cuisine_name">{{ orders.cuisine_name.join(", ") }}</p>
                      <a class="mt-2 d-inline-block" v-if="orders.support_contact_number != '' && orders.support_contact_number != null" :href="'tel:' + orders.support_contact_number">
                        <i class="fas fa-phone-alt"></i> {{ $t("Call") }}
                      </a>
                    </div>
                  </div>
                </div>
                <div class="inner-data">
                  <h6 class="mb-1 mt-3">{{ $t("Your Order") }}</h6>
                  <div
                    class="order-history-main"
                    v-for="(restaurant, index) in orders.restaurant_item_details" :key="index">
                    <div class="order-histry d-flex justify-content-between align-items-start">
                      <div class="histry-name nw-histry-name item-heading delivery-link">
                        <div class="veg" v-if="restaurant.item_type == 0">
                          <span></span>
                        </div>
                        <div class="non-veg" v-else-if="restaurant.item_type == 1" >
                          
                          <img class="non-veg-img" src="@/assets/images/non_veg.png" />
                        </div>
                        <div v-else-if="restaurant.item_type == 2">
                          <span></span>
                        </div>
                        <p class="mb-0">{{ restaurant.restaurant_menu_item_name }}</p>
                        <span class="itmcnt">{{ restaurant.quantity }} {{ $t("item") }}</span>
                        <div class="oderoptions" v-if="restaurant.custmisation.length > 0">
                          <span v-for="(subtype,i) in restaurant.custmisation" :key="i">
                            {{subtype.type_name}}
                            <span v-if="subtype.option.length > 0">
                              <span v-for="(option,ii) in subtype.option" :key="ii">[{{option.selection_name}}]
                                <span v-if="option.options.length > 0">
                                  <span v-for="(sub,iii) in option.option" :key="iii">
                                    {{sub.selection_name}}
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </div>                        
                      </div>
                      <div class="histry-price" v-if="restaurant.amount > 0">
                        <span v-html="$auth.setting.currency" class="currency"></span>
                        <span>{{
                          parseFloat(restaurant.amount).toFixed(2)
                        }}</span>
                                                <p class="mb-0" v-if="( restaurant.price < restaurant.mrp )">
                          <del>                   
                          <span
                            id="currency"
                            v-html="$auth.setting.currency"
                            class="currency"
                          ></span
                          >{{ restaurant.mrp * restaurant.quantity }} 
                         </del>
                        </p>
                      </div>
                      <div class="histry-price" v-else style="color: #27ae60;">
                        <span>Free</span>      
                        <p class="mb-0" v-if="( restaurant.price < restaurant.mrp )">
                          <del>                   
                          <span
                            id="currency"
                            v-html="$auth.setting.currency"
                            class="currency"
                          ></span
                          >{{ restaurant.mrp * restaurant.quantity }} 
                         </del>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="billing-data border-0 mt-2">
                    <h6 class="mb-2">{{ $t("Billing Details") }}</h6>
                    <ul>
                      <li class="d-flex justify-content-between">
                        {{ $t("SubTotal") }}
                        <div>
                          <span v-html="$auth.setting.currency" class="currency"></span>
                          <span>{{
                            parseFloat(orders.sub_total).toFixed(2)
                          }}</span>
                        </div>
                      </li>
                      <li class="d-flex justify-content-between" v-if="orders.delivery_fee > 0">
                        {{ $t("Delivery Charges") }}
                        <div>
                          <span v-html="$auth.setting.currency" class="currency"></span>
                          <span>{{
                            parseFloat(orders.delivery_fee).toFixed(2)
                          }}</span>
                        </div>
                      </li>
                      <li class="d-flex justify-content-between" v-if="orders.total_packaging_charge">
                        {{ $t("Packaging Charges") }}
                        <div>
                          <span v-html="$auth.setting.currency" class="currency"></span>
                          <span>{{
                            parseFloat(orders.total_packaging_charge).toFixed(2)
                          }}</span>
                        </div>
                      </li>
                      <li class="d-flex justify-content-between" v-if="orders.CGST">
                        {{ $t("CGST") }}({{orders.cgst_percentage}}%)
                        <div><span v-html="$auth.setting.currency" class="currency"></span>
                        <span>{{parseFloat(orders.CGST).toFixed(2)}}</span>
                        </div>
                      </li>
                      <li class="d-flex justify-content-between" v-if="orders.SGST">
                        {{ $t("SGST") }}({{orders.sgst_percentage}}%)
                        <div><span v-html="$auth.setting.currency" class="currency"></span>
                        <span>{{parseFloat(orders.SGST).toFixed(2)}}</span>
                        </div>
                      </li>
                      <li class="d-flex justify-content-between promo-discount" v-if="orders.cashback && orders.cashback > 0">{{ $t("Cashback") }}
                        <div>
                          <span v-html="$auth.setting.currency" class="currency"></span>
                          <span>{{parseFloat(orders.cashback).toFixed(2)}}</span>
                        </div>
                      </li>
                      <li class="d-flex justify-content-between discount-price" v-if="orders.discount_price && orders.discount_price > 0">{{ $t("Discount") }}
                        <div>
                          <span v-html="$auth.setting.currency" class="currency"></span>
                          <span>{{parseFloat(orders.discount_price).toFixed(2)}}</span>
                        </div>
                      </li>
                      <li class="d-flex justify-content-between bold">
                        {{ $t("Total Paid") }}
                        <div>
                          <span v-html="$auth.setting.currency" class="currency"></span>
                          <span>{{parseFloat(orders.total_amount).toFixed(2)}}</span>
                        </div>
                      </li>
                      <li class="d-flex justify-content-between walltline"
                        v-if="orders.wallet_amount > 0"
                      >
                        {{ $t("Wallet") }}
                        <div class="walltline">
                          - <span v-html="$auth.setting.currency" class="currency"></span
                          ><span>{{
                            parseFloat(orders.wallet_amount).toFixed(2)
                          }}</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="billing-data border-0 mt-2">
                    <h6 class="mb-2">{{ $t("Order Details") }}</h6>
                    <ul>
                      <li class="d-flex justify-content-between">
                        {{ $t("Order Number") }}
                        <span>#{{ orders.order_id }}</span>
                      </li>
                      <li class="d-flex justify-content-between">
                        {{ $t("Placed Date") }}
                        <span>{{moment(orders.order_date).format("DD/MM/Y hh:mm A")}}</span>
                      </li>
                      <li class="d-flex justify-content-between">
                        {{ $t("Order Type") }}
                        <span>{{ $t(orders.delivery_pickup_types) }}</span>
                      </li>
                      <li class="d-flex justify-content-between">
                        {{ $t("Payment Mode") }}
                        <span>{{ $t(orders.payment_method) }}
                        </span>
                      </li>
                      <li class="d-flex justify-content-between delivery-locality"  v-if="orders.delivery_pickup_types == 'Delivery'">
                        {{ $t("Delivery Address") }}
                        <span>{{ orders.delivery_address }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div id="past" v-if="orders.cancelled_desc" class="tab-pane tab-box cncel-ordr">
              <h6>{{ $t("Cancelled Order") }}</h6>
            </div>
          </div>

          <div class="order-offers" v-if="ordersDetail.length == 0 && !loading">
            <p class="text-center">{{ $t("No Order Found") }}</p>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>
<script>
import NavBar from "@/components/NavBar.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";
import Footer from "../components/Footer.vue";
import {imageErrorHandle} from "../helper/helper"
export default {
  components: {
    NavBar,
    Footer,
  },
  data() {
    return {
      imageErrorHandle:imageErrorHandle,
      ordersDetail: [],
      moment: moment,
      loading: true,
      invoiceLoadingId: null,
    };
  },
  computed: {
    ...mapGetters("order", ["orderDetail"]),
  },
  mounted() {
    if (this.$auth.user) {
      this.orderDetails();
    } else {
      this.$router.push({ name: "sign-in" });
    }
  },
  methods: {
    ...mapActions("order", ["viewOrderDetail", "downloadInvoicePDF"]),
    async invoiceGenerate(id){
      if (this.invoiceLoadingId) return;
      this.invoiceLoadingId = id;
      try {
        var order_id = id + "," + this.$auth.getVendorId();
        order_id = btoa(order_id);

        const response = await this.downloadInvoicePDF({ order_id: order_id });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = `Order_Invoice_${id}.pdf`;
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('PDF download failed:', error);
      } finally {
        this.invoiceLoadingId = null;
      }
    },
    orderDetails() {
      this.loading = true;
      if (this.isBase64(this.$route.params.order_id)) {
        this.viewOrderDetail({
          vendor_id: this.$auth.getVendorId(),
          order_id: this.base64_decode(this.$route.params.order_id),
          is_langauge: this.$store.state.lang.locale,
        }).then((data) => {
          if (data.code == 200) {
            this.loading = false;
            this.ordersDetail = data.Result;
          }
          if (data.code == 101) {
            this.loading = false;
            this.ordersDetail = [];
          }
        });
      } else {
        this.loading = false;
        this.ordersDetail = [];
      }
    },

    isBase64(str) {
      if (str === "" || str.trim() === "") {
        return false;
      }
      try {
        return btoa(atob(str)) == str;
      } catch (err) {
        return false;
      }
    },
  },
};
</script>
<style scoped>
.invoice-btn {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;
}
.invoice-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
</style>